/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconShoppingCart = createReactComponent("shopping-cart", "IconShoppingCart", [
  ["path", { d: "M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-0" }],
  ["path", { d: "M17 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-1" }],
  ["path", { d: "M17 17h-11v-14h-2", key: "svg-2" }],
  ["path", { d: "M6 5l14 1l-1 7h-13", key: "svg-3" }]
]);

export { IconShoppingCart as default };
//# sourceMappingURL=IconShoppingCart.js.map
